var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.className, { reset: _vm.reset }],attrs:{"slot":"item"},slot:"item"},[_c('esi',{attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }